import Image from "next/image";

export default function SummaryPdfTestimonials() {
  return (
    <div className="bg-amber-50 dark:bg-amber-950/30 p-6 rounded-lg border-l-4 border-amber-500">
      <h3 className="text-lg font-semibold text-amber-800 dark:text-amber-200 mb-4">
        💬 25년 3회 실기 시험을 본 분들의 반응
      </h3>
      <p className="text-gray-600 text-sm mb-4">
        정처기 감자를 이용하고 2025년 3회 실기 시험을 봤던 분들의
        실제 반응입니다.
      </p>

      {/* 유튜브 댓글 */}
      <div className="mb-6">
        <p className="text-amber-700 dark:text-amber-300 font-medium text-sm mb-3 flex items-center">
          <span className="mr-2">📺</span> 유튜브 댓글
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 items-start">
          {[1, 2, 3, 4].map((num) => (
            <div
              key={`youtube-${num}`}
              className="rounded-lg overflow-hidden shadow-sm border border-amber-200"
            >
              <Image
                src={`/summary-pdf/26-1-compressed/review/youtube${num}.webp`}
                alt={`유튜브 댓글 ${num}`}
                width={400}
                height={200}
                className="w-full h-auto"
              />
            </div>
          ))}
        </div>
      </div>

      {/* 정처기 감자 댓글 */}
      <div className="mb-6">
        <p className="text-amber-700 dark:text-amber-300 font-medium text-sm mb-3 flex items-center">
          <span className="mr-2">🥔</span> 정처기 감자 댓글
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 items-start">
          {[1, 2, 3, 4].map((num) => (
            <div
              key={`comment-${num}`}
              className="rounded-lg overflow-hidden shadow-sm border border-amber-200"
            >
              <Image
                src={`/summary-pdf/26-1-compressed/review/comment${num}.webp`}
                alt={`정처기 감자 댓글 ${num}`}
                width={400}
                height={200}
                className="w-full h-auto"
              />
            </div>
          ))}
          {[5, 6].map((num) => (
            <div
              key={`comment-${num}`}
              className="rounded-lg overflow-hidden shadow-sm border border-amber-200"
            >
              <Image
                src={`/summary-pdf/26-1-compressed/review/2/comment${num}.webp`}
                alt={`정처기 감자 댓글 ${num}`}
                width={400}
                height={200}
                className="w-full h-auto"
              />
            </div>
          ))}
        </div>
      </div>

      {/* 인스타그램 */}
      <div className="mb-6">
        <p className="text-amber-700 dark:text-amber-300 font-medium text-sm mb-3 flex items-center">
          <span className="mr-2">📸</span> 인스타그램
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 items-start">
          {[1, 2].map((num) => (
            <div
              key={`insta-${num}`}
              className="rounded-lg overflow-hidden shadow-sm border border-amber-200"
            >
              <Image
                src={`/summary-pdf/26-1-compressed/review/2/insta${num}.webp`}
                alt={`인스타그램 ${num}`}
                width={400}
                height={200}
                className="w-full h-auto"
              />
            </div>
          ))}
        </div>
      </div>

      {/* 카카오톡 */}
      <div>
        <p className="text-amber-700 dark:text-amber-300 font-medium text-sm mb-3 flex items-center">
          <span className="mr-2">💬</span> 카카오톡
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 items-start">
          <div className="rounded-lg overflow-hidden shadow-sm border border-amber-200">
            <Image
              src="/summary-pdf/26-1-compressed/review/2/kakao1.webp"
              alt="카카오톡 1"
              width={400}
              height={83}
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );

}
